import css from 'styled-jsx/css';
import { colors } from '../../../themes';

export default css`
  .main {
    display: flex;
    flex-direction: column;
    height: 100vh;
    padding: 50px 25px 25px;
    text-align: center;
  }

  .content {
    display: flex;
    flex-direction: column;
    flex: 1 0 auto;
    justify-content: flex-end;
    padding: 25px;
    text-align: center;
  }

  img {
    display: block;
    margin: 0 auto;
  }

  h1 {
    color: ${colors.grayDeep};
    font-size: 1.125em; /* 18/16 */
    font-weight: bold;
    line-height: 1.25;
    margin: 30px 0 20px;
  }
`;



// WEBPACK FOOTER //
// ./app/Error/components/Error500/styles.js